import { Tournament } from '../models';
import { TournamentRepository } from '../repositories';

export class GetAllTournamentsUseCase {
  constructor(private tournamentRepository: TournamentRepository) {}

  async execute(limit?: number, offset?: number): Promise<Tournament[]> {
    return await this.tournamentRepository.getAll(limit, offset);
  }
}
